import React from 'react';
import { Route } from "react-router-dom";
import EntitiesList from './entities.list';
import EntitiesView from './entities.view';
import store from './filterStore';

const EntitiesRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={EntitiesView} />
    <Route
      exact
      path={match.path}
      render={() => <EntitiesList store={store} />}
    />
  </div>
);

export default EntitiesRouter;
